import Vue from "vue";
import { filterFast, sortArrayByProp, containsAllElements, insertArrayInArray, deduplicateArrayOfObject, deduplicateArray, replaceItemInList } from '../utils/array-handling';
Vue.mixin({
    data() {
        return { filterFast, sortArrayByProp, containsAllElements, insertArrayInArray, deduplicateArrayOfObject, deduplicateArray, replaceItemInList }
    },
    methods: {
        findListMatchKeys(item, inputKeyword) {
            const keyword = inputKeyword.toLowerCase();
            const result = [];
            for (const key of Object.keys(item)) {
                if (['password', 'email_username', 'resume', 'profile_pic', 'modelMatches'].includes(key)) {
                    continue;
                }
                if (key.indexOf('file') === 0) {
                    continue;
                }
                let value = item[key];
                if (!value) {
                    continue;
                }
                if (Array.isArray(value)) {
                    value = value.join(' ');
                }
                if (typeof value === 'string' && value.toLowerCase().includes(keyword)) {
                    result.push(key);
                }
            }
            return result;
        },
        // Search for all items which has any attributes contains keyword
        searchInListObject(listItems, keyword) {
            const result = [];
            for (const item of listItems) {
                item.modelMatches = [];
                const listKeys = this.findListMatchKeys(item, keyword);
                item.modelMatches = listKeys;
                if (listKeys && listKeys.length) {
                    result.push(item);
                }
            }
            return result;
        },
        searchInListObjectAnyKeywords(listItems, listKeywords) {
            const result = [];
            for (const item of listItems) {
                let isMatch = false;
                let listMatchingKeys = [];
                for (const keyword of listKeywords) {
                    const listKeys = this.findListMatchKeys(item, keyword);
                    if (listKeys && listKeys.length) {
                        listMatchingKeys = listMatchingKeys.concat(listKeys);
                        isMatch = true;
                    }
                }
                if (isMatch) {
                    item.modelMatches = [...new Set(listMatchingKeys)]
                    result.push(item);
                }
            }
            return result;
        },
        searchInListObjectAllKeywords(listItems, listKeywords) {
            const result = [];
            for (const item of listItems) {
                let isMatch = true;
                let listMatchingKeys = [];
                for (const keyword of listKeywords) {
                    const listKeys = this.findListMatchKeys(item, keyword);
                    if (listKeys && listKeys.length) {
                        listMatchingKeys = listMatchingKeys.concat(listKeys);
                    } else {
                        isMatch = false;
                        break;
                    }
                }
                if (isMatch) {
                    item.modelMatches = [...new Set(listMatchingKeys)]
                    result.push(item);
                }
            }
            return result;
        },
        trimElementOfList(inputArr) {
            if (!Array.isArray(inputArr)) {
                return inputArr;
            }
            return inputArr.map(item => {
                if (typeof item === 'string') {
                    return item.trim();
                } else if (typeof item === 'object') {
                    for (const key of Object.keys(item)) {
                        if (typeof item[key] === 'string') {
                            item[key] = item[key].trim();
                        }
                    }
                    return item;
                } else {
                    return item;
                }
            })
        },
        calculateSumOfProperty(inputArr, prop, transformFunc) {
            if (!inputArr) {
                return 0;
            }
            return inputArr.reduce((acc, cur) => {
                let val;
                if (prop) {
                    val = this.getValueOfObjectKey(cur, prop);
                } else if (transformFunc) {
                    val = transformFunc(cur);
                }
                if (!val) {
                    return acc;
                }
                return acc + Number(val);
            }, 0);
        },
        cloneArrayOfObject(inputArr) {
            const result = [];
            for (const item of inputArr) {
                result.push({ ...item });
            }
            return result;
        },
        groupArrayByKey(list, key) {
            return list.reduce((hash, obj) => ({ ...hash, [obj[key]]: (hash[obj[key]] || []).concat(obj) }), {})
        },
        filterArrayOfObjectsWithOptions(inputArr, filteredValues, matchingOption, key) {
            if (!inputArr) {
                return [];
            }
            if (filteredValues && filteredValues.length) {
                if (matchingOption === "All Of") {
                    return inputArr.filter((item) =>
                        this.containsAllElements(
                            item[key],
                            filteredValues
                        )
                    );
                } else if (matchingOption === "Any Of") {
                    return inputArr.filter((item) =>
                        this.hasCommonElement(
                            item[key],
                            filteredValues
                        )
                    );
                } else if (matchingOption === "None Of") {
                    return inputArr.filter(
                        (item) =>
                            !this.hasCommonElement(
                                item[key],
                                filteredValues
                            )
                    );
                }
            }
            return inputArr;
        },
        arrayMove(arr, oldIndex, newIndex) {
            const length = arr.length;
            const itemToMove = arr[oldIndex]
        
            if (oldIndex === newIndex || oldIndex > length || newIndex > length) {
                return arr;
            }
        
            return arr.reduce((acc, item, index) => {
                if (index === oldIndex) return acc;
                if (index === newIndex) return oldIndex < newIndex ? [...acc, item, itemToMove] : [...acc, itemToMove, item];
                return [...acc, item];
            }, [])
        }
    }
});


// WEBPACK FOOTER //
// ./src/mixins/array-handling.js